import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { TopBar, ModalConfirmCode } from "../components";
import { LoginContainer } from "../components";
import { pageLoginText } from "../lib/constants";
import { confirmCode, sendCode } from "../service/login-service";
import { setLogin } from "../components/utils/auth";
import "./style/PageLogin.css";

export const PageLogin = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [modalError, setModalError] = useState(null);

  const handleShowModal = (email, userId = null) => {
    setUserEmail(email);
    setUserId(userId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalError(null);
  };

  const handleConfirmCode = async (code) => {
    setIsLoading(true);
    setModalError(null);
    
    try {
      if (!userId) {
        setModalError("Error interno: ID de usuario no encontrado.");
        setIsLoading(false);
        return;
      }
      
      const response = await confirmCode(userId, code);
      const { jwt, user } = response;

        setLogin({
          token: jwt,
          client: "web",
          uid: user.id,
          name: user.name,
        });
        
        setShowModal(false)
        history.replace("/");
    } catch (error) {
      const message = error.response.data.error;
      setModalError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendCode = async () => {
    setIsResending(true);
    setModalError(null);
    
    try {
      const response = await sendCode(userEmail);
      setUserId(response.user_id);
    } catch (error) {
      setModalError(error.response.data.error);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="page-login d-flex flex-column">
      <TopBar content={pageLoginText.top_bar_content} />
      <LoginContainer onShowModal={handleShowModal} />
      
      <ModalConfirmCode
        show={showModal}
        onHide={handleCloseModal}
        email={userEmail}
        onConfirm={handleConfirmCode}
        onResendCode={handleResendCode}
        isLoading={isLoading}
        isResending={isResending}
        error={modalError}
      />
    </div>
  );
};

export default PageLogin;
